module.exports = __webpack_public_path__ + "img/employe_search.30c9b830.svg";